import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

interface RegionTooltipProps {
  children: (tootlip: string) => React.ReactElement;
  onClick: () => void;
}

const Wrapper = styled.div`
  cursor: pointer;
`;

export function RegionTooltip({ children, onClick }: RegionTooltipProps): JSX.Element {
  const { t } = useTranslation();

  const tooltip = ` - ${t('highlights:heatmaps.create.tooltip')}`;

  return <Wrapper onClick={onClick}>{children(tooltip)}</Wrapper>;
}
